import LicensePlates from 'feature/license-plates/license-plates';

export default LicensePlates;
